/**
 * ArchiveSidebar
 * ======================================
 * - collapse category list on mobile
 */

const EL = '.js-archive-sidebar'

document.querySelectorAll(EL).forEach(el => {
  if (window.matchMedia('(max-width: 1023px)').matches) {
    el.removeAttribute('open')
  }
})
